import { useMemo, useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { toTitleCase } from "../../../utils/helpers/logicHelper";
import FieldHelp from "../FieldHelp";

const NUMBER = ({ divClass, inputClass, formControl, formHook, initialValue, showHelp, helpText }) => {
  const [validatorSchema, setValidatorSchema] = useState({});
  const errors = formHook.formState.errors || formHook.formState.errors[formControl["key"]];
  const shouldShowHelp = showHelp && helpText;
  const helpId = `field-help-${formControl["key"]}`;

  useMemo(() => {
    for (const [key, value] of Object.entries(formControl)) {
      switch (key) {
        case 'required':
          if (value) setValidatorSchema(prevState => ({ ...prevState, required: `${formControl["label"]} is required.` }));
          break;
        case 'max_length':
          setValidatorSchema(prevState => ({
            ...prevState,
            max: { value, message: `Maximum of ${value} is required.` }
          }));
          break;
        case 'min_length':
          if (value) setValidatorSchema(prevState => ({
            ...prevState,
            min: { value, message: `Minimum of ${value} is required.` }
          }));
          break;
        default:
          break;
      }
    }
  }, []);


  return (
    <div className={`${divClass} ${shouldShowHelp ? "field-with-help" : ""}`.trim()}>
      <label htmlFor={formControl["key"]}>
        {toTitleCase(formControl["label"])} {formControl["required"] && <span className="text-danger">*</span>}
      </label>
      <div className="field-input-wrap">
        <input
          className={inputClass || ""}
          type={formControl["type"]}
          name={formControl["key"]}
          max={formControl["max_length"]}
          min={formControl["min_length"]}
          placeholder={formControl["placeholder"]}
          defaultValue={initialValue ?? formControl["default_value"]}
          {...formHook.register(formControl["key"], { ...validatorSchema, valueAsNumber: true, })}
        />
        {shouldShowHelp && <FieldHelp id={helpId} text={helpText} />}
      </div>
      <ErrorMessage
        errors={errors}
        name={formControl["key"]}
        render={(error) =>
          error &&
          Object.entries(error).map(([type, message]) => (
            <small key={type} className="text-danger mt-1">{message}</small>
          ))
        }
      />
    </div>
  );
}
export default NUMBER;
